import Model, { attr } from '@ember-data/model';

export enum ReviewStatisticCategory {
  overallRating = 'overall_rating',
  accuracy = 'accuracy',
  value = 'value',
  cleanliness = 'cleanliness',
  checkIn = 'checkin',
  communication = 'communication',
  location = 'location',
}

export default class ReviewStatisticCategoryModel extends Model {
  @attr('string') category!: ReviewStatisticCategory;
  @attr('string') month!: string;
  @attr('number') rating!: number;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'review-statistic-category': ReviewStatisticCategoryModel;
  }
}
